import type { Client } from './api/client';
import { getUsersByPermission, getUsersByWorkosRoles } from './api';

/** Permission slug for users who may work intakes (aligns with intake page `intake:access` checks). */
export const INTAKE_ASSIGNEE_RBAC_PERMISSION_SLUG = 'intake:assignable';

/**
 * Users eligible to appear in intake assignee pickers.
 * When RBAC is enabled for the org, uses agency-scoped permission grants; otherwise WorkOS role `intake`.
 */
export function fetchIntakeAssignableUsers(
  client: Client,
  useRogerRbac: boolean
) {
  if (useRogerRbac) {
    return getUsersByPermission({
      client,
      query: { permission: INTAKE_ASSIGNEE_RBAC_PERMISSION_SLUG },
    });
  }
  return getUsersByWorkosRoles({
    client,
    body: ['intake'],
  });
}
